module.exports = __webpack_public_path__ + "Roboto-Light.183079184d96a491f16e.eot";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-Light.eot
// module id = 112
// module chunks = 19